export const PROFILE_TABS = {
    OVERVIEW: 'overview',
    REFERRALS: 'referrals',
    SAVED: 'saved',
    SETTINGS: 'settings'
  }
  
  export const USER_ROLES = {
    ADMIN: 'admin',
    DEVELOPER: 'developer',
    AGENT: 'agent',
    LEAD: 'lead'
  }
  
  export const REFERRAL_STATUS = {
    COMPLETED: 'completed',
    PENDING: 'pending'
  }
  
  export const REWARD_STATUS = {
    PAID: 'paid',
    PENDING: 'pending'
  }
  
  export const NOTIFICATION_SETTINGS = [
    { id: 'email', title: 'Email Notifications', desc: 'Property updates and newsletters', enabled: true },
    { id: 'sms', title: 'SMS Notifications', desc: 'Important account alerts', enabled: false },
    { id: 'push', title: 'Push Notifications', desc: 'Browser notifications', enabled: true },
    { id: 'referral', title: 'Referral Updates', desc: 'When your referrals sign up', enabled: true }
  ]
  